import React from 'react';
import { connect } from 'react-redux';
import { Form, Grid, Select } from 'semantic-ui-react';
import { defaultGrid } from '../../helpers/datagrid';
import DataGrid from '../shared/DataGrid';
import RefreshSlider from '../shared/RefreshSlider';
import DetailsButton from '../shared/DetailsButton';
import livefloorview from '../../api/livefloorview';
import { showSiteDetailsModal } from '../../redux/actions/modals';
import { checkForUpdates, prepareFilter } from '../../redux/actions';

class SiteDetailsTab extends React.Component {

  state = {
    selectedDetailOption: 0,
    selectedPeriod: 0,
    activeRow: null,
    grid: defaultGrid,
    loading: false,
    detailsLoading: false
  };
  
  componentDidUpdate(prevProps, prevState) {
    const currentId = this.props.filters.filterSelected.site.id

    if (checkForUpdates(prevProps.filters, this.props.filters)) {
      this.handleRefresh(() => {
        const { grid } = this.state;
        if (currentId && grid.data.length == 1) {
          this.setState({ activeRow: { ...grid.data[0] } }, () => this.onDetailsClick());
        } 
      });
    }
  }

  handleRefresh = (callback = () => {}) => {
    const { filterSelected, filterData } = this.props.filters;
    const { operator, company, subcompany, site } = filterSelected
    const { selectedDetailOption } = this.state;
    this.setState({ loading: true }, () => {
      const fn = selectedDetailOption == 0 ? livefloorview.getCashInBoxGrid : livefloorview.getPerformanceGrid;
      fn(
        operator,
        company.id,
        subcompany.id,
        site.id,
        prepareFilter(filterSelected.manufacturer, filterData.manufacturer),
        prepareFilter(filterSelected.game, filterData.game),
        prepareFilter(filterSelected.machinetypes, filterData.machinetypes),
      ).then(
        grid => this.setState({ activeRow: null, grid, loading: false }, () => callback()),
        () => this.setState({ loading: false })
      );
    })
  }

  onDetailsClick = () => {
    const { selectedDetailOption } = this.state;
    const { siteId } = this.state.activeRow;
    const isCashInBox = selectedDetailOption === 0;

    const positionsFn = isCashInBox ? livefloorview.getCashInBoxPositions : livefloorview.getPerformancePositions;
    const eventsFn = isCashInBox ? livefloorview.getCashInBoxEvents : livefloorview.getPerformanceEvents;
    const modalTitle = isCashInBox ? "Cash In Box" : "Performance - Current Collection Week";

    this.props.showSiteDetailsModal(
      siteId,
      modalTitle,
      positionsFn,
      eventsFn
    )
  }

  onRowClick = activeRow => this.setState({ activeRow }, () => console.log(activeRow.siteId));

  render() {

    const detailOptions = [
      { key: "Cash In Box", value: 0, text: "Cash In Box"},
      { key: "Performance", value: 1, text: "Performance"},
    ]

    const periodOptions = [
      { key: "Current Collection Week", value: 0, text: "Current Collection Week"},
    ]

    const { selectedDetailOption, loading, selectedPeriod, grid, activeRow, detailsLoading } = this.state;

    return (
      <Grid relaxed className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="12">
            <Form>
              <Form.Group inline>
                <Form.Field>
                  <Select options={detailOptions} value={selectedDetailOption} onChange={(event, { value }) => this.setState({ selectedDetailOption: value })} />
                </Form.Field>
                { selectedDetailOption == 1 && 
                  <Form.Field>
                    <Select options={periodOptions} value={selectedPeriod} onChange={(event, { value }) => this.setState({ selectedPeriod: value })} />
                  </Form.Field>
                }
                <RefreshSlider refresh={() => this.handleRefresh()} />
              </Form.Group>
            </Form>
          </Grid.Column>
          <Grid.Column textAlign="right" width="4">
            <DetailsButton disabled={!activeRow || loading} onClick={this.onDetailsClick} loading={detailsLoading} />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column className="gs-flex-container-vertical">
            <DataGrid
              loading={loading}
              headings={grid.headerDef}
              rowDef={grid.rowDef}
              data={grid.data}
              groupHeadings={grid.span}
              onRowClick={this.onRowClick}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};

const mapStateToProps = state => {
	return {
    filters: state.LiveFloorViewerFilters,
  };
};

export default connect(mapStateToProps, { showSiteDetailsModal })(SiteDetailsTab);
